(()=>{
  'use strict';
  if(window.__svPhase12LaunchReadiness)return;
  window.__svPhase12LaunchReadiness=true;

  const $=(selector,root=document)=>root.querySelector(selector);
  const $$=(selector,root=document)=>Array.from(root.querySelectorAll(selector));
  let metadataObserver=null;
  let metadataNodes=[];
  let emitQueued=false;

  function getMain(){
    return document.getElementById('MainContent')||document.querySelector('main');
  }

  function cleanPath(){
    const path=String(window.location.pathname||'/').replace(/\/+$/,'');
    return path||'/';
  }

  function detectNavigationState(){
    const path=cleanPath();
    const main=getMain();

    if(path==='/')return 'Home';

    if(
      path.startsWith('/search')||
      path.includes('/pages/search')||
      path.includes('/pages/song-valley-search')||
      path.includes('/pages/discover')
    )return 'Search';

    if(
      path.includes('/pages/artists')||
      main?.querySelector('.sv3p[data-sv3],[data-sv-artist-profile]')
    )return 'Artists';

    if(
      path.includes('/pages/projects')||
      main?.querySelector('.sv4[data-sv4],[data-sv-project-tracks]')
    )return 'Projects';

    return '';
  }

  function syncAppNavigation(){
    const current=detectNavigationState();
    $$('.sv-app-nav-item').forEach((item)=>{
      const label=$('.sv-app-nav-label',item)?.textContent?.trim()||'';
      const active=Boolean(current&&label===current);
      item.classList.toggle('is-active',active);
      if(active)item.setAttribute('aria-current','page');
      else item.removeAttribute('aria-current');
    });
  }

  function simplifyDirectory(){
    $$('.sv-directory').forEach((directory)=>{
      $$('.sv-directory-browse',directory).forEach((browse)=>browse.remove());
      directory.classList.add('sv-directory--breadcrumb-only');
      directory.setAttribute('aria-label','SongValley breadcrumb');

      const currentItems=$$('.sv-directory-current',directory);
      currentItems.forEach((item,index)=>{
        item.classList.toggle('sv-directory-current--last',index===currentItems.length-1);
      });
    });
  }

  function refreshPhase1(){
    if(typeof window.__svPhase1Apply!=='function')return;
    try{
      window.__svPhase1Apply();
    }catch(error){
      console.warn('SongValley Phase 12 could not refresh Phase 1.',error);
    }
  }

  function emitPlayerMetadataChange(){
    if(emitQueued)return;
    emitQueued=true;
    window.requestAnimationFrame(()=>{
      emitQueued=false;
      const player=window.SongValleyPlayer||null;
      document.dispatchEvent(new CustomEvent('songvalley:playback-change',{
        detail:{
          playing:Boolean(player&&typeof player.isPlaying==='function'&&player.isPlaying()),
          track:player&&typeof player.getCurrentTrack==='function'?player.getCurrentTrack():null,
          source:'phase12-metadata-bridge'
        }
      }));
    });
  }

  function bindPlayerMetadataBridge(){
    const title=document.getElementById('sv-global-title');
    const artist=document.getElementById('sv-global-artist');
    const cover=document.getElementById('sv-global-cover');
    const nodes=[title,artist,cover].filter(Boolean);
    if(!nodes.length)return;

    const sameNodes=
      nodes.length===metadataNodes.length&&
      nodes.every((node,index)=>node===metadataNodes[index]);
    if(sameNodes)return;

    if(metadataObserver)metadataObserver.disconnect();
    metadataNodes=nodes;
    metadataObserver=new MutationObserver(emitPlayerMetadataChange);

    if(title)metadataObserver.observe(title,{childList:true,subtree:true,characterData:true});
    if(artist)metadataObserver.observe(artist,{childList:true,subtree:true,characterData:true});
    if(cover)metadataObserver.observe(cover,{attributes:true,attributeFilter:['src','class']});
  }

  function run(){
    refreshPhase1();
    simplifyDirectory();
    syncAppNavigation();
    bindPlayerMetadataBridge();
    document.documentElement.dataset.svPhase12='ready';
  }

  ['songvalley:page:loaded','shopify:section:load'].forEach((eventName)=>{
    document.addEventListener(eventName,()=>window.requestAnimationFrame(run));
  });

  window.addEventListener('pageshow',run);
  window.addEventListener('popstate',()=>window.requestAnimationFrame(run));

  window.SongValleyPhase12={refresh:run};

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
})();
